export default __webpack_public_path__ + "static/media/20.0e805ba8.jpg";